<template>
  <div style="margin-right: 30px">
    <!--查看审批记录-->
    <a-button v-if="instanceId"
              type="primary"
              @click="showHisPanel">查看审批记录
    </a-button>

    <a-modal
        title="查看审批记录"
        centered
        :visible="showHistory"
        :footer="null"
        @cancel="showHistory = false"
        :width="800"
    >
      <div style="width: 700px;height: 200px;background: #fff;margin: 0 auto">
        <img style="width: 100%;height: 100%;object-fit: contain" :src="recordImg" alt="">
      </div>

      <vxe-grid
          ref="xGrid"
          column-key
          class="column-sortable-grid"
          v-bind="gridOptions"
          :data="list"
          :auto-resize="true"
      >
      </vxe-grid>
    </a-modal>

  </div>
</template>

<script>
import {dataApi} from '@/services/workflow/workflow';
import api from '@/services/api'
import {mapGetters} from 'vuex'

export default {
  computed: {
    ...mapGetters('account', ['user'])
  },
  props: {
    /**
     * 业务编号
     */
    bussinessNo: {
      type: String,
      default: ''
    },
    /**
     * 业务主键
     */
    keyId: {
      default: ''
    }
  },
  data() {
    return {
      showHistory: false,
      list:[],
      gridOptions: {
        border: true,
        resizable: true,
        showHeaderOverflow: true,
        showOverflow: true,
        highlightHoverRow: true,
        keepSource: true,
        // id: this.id,
        height: 300,
        columns: [{
          field: "nodeName",
          title: "节点名称",
          width: 160,
        }, {
          field: "username",
          title: "审批人",
          width: 120,
        }, {
          field: "operateType",
          title: "操作类型",
          width: 120,
        }, {
          field: "operateDate",
          title: "审批时间",
          width: 160,
        }, {
          field: "decision",
          title: "审批意见",
          width: 300,
        }],
      },
      recordImg: '',
      instanceId: ''
    }
  },
  watch: {
    /**
     * 监听状态判断
     */
    keyId: {
      immediate: true,
      async handler(val) {
        if (val > 0) {
          let data = await dataApi.getInfo(this.keyId, this.bussinessNo);
          this.instanceId = data.data.instanceId;
        }
      }
    }
  },
  // async mounted() {
  //   console.log(this.keyId, this.bussinessNo)
  //   let data = await dataApi.getInfo(this.keyId, this.bussinessNo);
  //   console.log(data);
  //   this.instanceId = data.data.instanceId;
  // },
  methods: {
    /**
     * 查看审批记录
     */
    async showHisPanel() {
      let res = await dataApi.getRecord(this.instanceId);
      this.list = res.data.list;
      this.recordImg = `${api.TEMP.BASE_URL}/act/explorer/read-resource?processInstanceId=${this.instanceId}&token=${this.user.token}`
      this.showHistory = true;
    },
  },

};
</script>

<style scoped type="less">
button {
  margin-left: 5px;
}

.ant-btn-danger {
  background: rgba(204, 204, 204, 0.2);
  border: 1px solid #ccc;
  color: #ccc;
}

.ant-btn-primary {
  background: rgba(3, 122, 129, 0.2);
  border: 1px solid #037a81;
  color: #037a81;
}
</style>

